import Utils from '@/utils/util.js';
import FileUtils from '@/utils/fileUtils.js';

export default {   
    data() {
        return {

            // File upload
            showFileUpload:false,
            fileUploadFileInfo:[],
            fileUploadParentInfo:{type:'', subType:'', index:0},
            //old file upload
            selectedFiles: undefined,
            currentFile: undefined,
            fileUploadProgress:0,       
        }
    },
    components: {      
    },
    
    created() {
    },
    props:{
    }, 
    methods: {
        showFileUploadsWindow (type, subType, parentID, fileInfo){ // index starts from 0
            if(this.isFileUploadAllowedForRole() == false){
                return;
            }
            this.showFileUpload                 = true;

            // reset
            this.fileUploadFileInfo = [];
       
            // - Parent info
            this.fileUploadParentInfo.type      = type;
            this.fileUploadParentInfo.subType   = subType;
            this.fileUploadParentInfo.parentID     = parentID;
            this.fileUploadParentInfo.fileNamePrefix     = Utils.getUniqueID();

            fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
        },  
        isFileUploadAllowedForRole(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                    return true;
                }
            }
            return false;
        },
        async uploadFiles(documents, folderName){           
            await FileUtils.uploadFileList(documents, folderName);          
            return true;
        },


                 
    },
    computed:{          
        fileUploadInfoGetter(){
            return this.$store.state.fileUploadInfo;
        },
    },
    watch: {
        
    }
    
    
}
